import { createFeatureSelector, createSelector } from "@ngrx/store";
import { SettingsState } from "@store/reducers/settings.reduer";

export const selectSettingsState = createFeatureSelector<SettingsState>('settings');

export const selectSettings = createSelector(
    selectSettingsState,
    (state: SettingsState) => state.settings
);
export const selectIsSettingLoading = createSelector(
    selectSettingsState,
    (state: SettingsState) => state.isLoading
);

export const selectSettingsError = createSelector(
    selectSettingsState,
    (state: SettingsState) => state.error
);
import { BUILTIN_PALETTES } from '@models/palette.model';

export const selectActivePaletteColors = createSelector(
  selectSettings,
  (settings) => {
    const id = settings.activePaletteId ?? 'dawnbringer16';
    const count = settings.paletteColorCount ?? 16;
    const builtin = BUILTIN_PALETTES.find(p => p.id === id);
    if (builtin) return builtin.colors.slice(0, count);
    const custom = (settings.customPalettes ?? []).find(p => p.id === id);
    if (custom) return custom.colors.slice(0, count);
    return BUILTIN_PALETTES[0].colors.slice(0, 16);
  }
);
